module.exports = __webpack_public_path__ + "static/media/sessionCredit.d49ce3ef.svg";